// Module
var code = "<md-button class=\"md-icon-button margin-0 all-filters-panel\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"edit\" class=\"md-16\"></md-icon> <md-tooltip md-delay=\"400\"> <span>{{'Edit Filters' | translate}}</span> </md-tooltip> </md-button> ";
// Exports
export default code;